import Api from '@utils/api';
import { Planes } from '@constants/urls';

export const state = {
    planes: [],
    isLoading: false
}

export const getters = {
    getPlanes: function(state){
        return state.planes;
    },
    getLoading: function(state){
        return state.isLoading;
    }
}

export const mutations = {
    SET_PLANES: function(state, newValue){
        state.planes = newValue;
    },
    SET_LOADING: function(state, newValue){
        state.isLoading = newValue;
    }
}

export const actions = {
    inicializarPlanes: function({ commit }) {
        commit('SET_LOADING', true);
        Api.Get(Planes.LISTAR)
          .then((response) => {
            commit('SET_PLANES', response.data.data);
          })
          .finally(() => {
            commit('SET_LOADING', false);
          });
    }
}
